module.exports = __webpack_public_path__ + "static/media/taeil-8.jpeg";